module.exports = __webpack_public_path__ + "img/offer1.4d46ddaf.png";